<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <h1 class="text-info font-size-18">Dados Do <strong>Fornecedor</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex infoDados>
        <v-card>
          <span class="linhaInfo" v-show="model.tipFornecedor =='J'">
            <v-icon>business</v-icon>{{$t('label.razaoSocial')}}:
            <strong class="text-cinza-6">
              <span style="text-transform: uppercase;" v-html="retornaIfCadastrado(model.nomFornecedor) "></span>
            </strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='F'">
            <v-icon>perm_identity</v-icon>{{$t('label.nome')}}:
            <strong class="text-cinza-6">
              <span v-html="retornaIfCadastrado(model.nomFornecedor)"></span>
            </strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='J' && model.flagEstrangeiro==0">
            <v-icon>edit</v-icon>{{$t('label.cnpj')}}:
            <strong
              class="text-cinza-6"
            >{{model.numCgcFornecedor|formatCpfCnpj}}</strong>
          </span>
          <span class="linhaInfo" v-show="model.tipFornecedor =='F' && model.flagEstrangeiro==0">
            <v-icon>edit</v-icon>{{$t('label.cpf')}}:
            <strong class="text-cinza-6">{{model.numCgcFornecedor|formatCpfCnpj}}</strong>
          </span>
          <span class="linhaInfo" v-show="model.flagEstrangeiro==1">
            <v-icon>edit</v-icon>{{$t('label.documentoIdentificacao')}}:
            <strong class="text-cinza-6">{{model.numCgcFornecedor}}</strong>
          </span>
          <span class="linhaInfo">
            <v-icon>lock</v-icon>Tipo de Cadastro Solicitado:
            <strong class="text-cinza-6">
              <span v-html="retornaEnumDescricao('tipoCertificado',model.tipoCertificado)"></span>
            </strong>
          </span>
          <span class="linhaInfo">
            <v-icon>date_range</v-icon>Data da Solicitação:
            <strong class="text-cinza-6">{{model.dataSolicitacao | dataHoraFormatada}}</strong>
          </span>
          <span class="linhaInfo">
            <v-icon>spellcheck</v-icon> SITUAÇÃO SIMPAS:
            <strong class="text-cinza-6">
              <span style="text-transform: uppercase;" v-html="retornaIfCadastrado(model.tbFornecedores ? retornaEnumDescricao('situacaoFornecedor',model.tbFornecedores.sitFornecedor): null)"></span>
            </strong>
          </span>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex p-t-30>
      <h1 class="text-info font-size-18">
        <strong>Documentos Rejeitados</strong>
      </h1>
   
      <div v-if="!this.documentosRejeitados">Nenhum documento obrigatório rejeitado.</div>

      <div class="p-t-20 boxFamilias" v-if="documentosHabilitacaoJuridicaRecusado.length > 0 || documentosDadosBasicosRecusado.length > 0 || this.habilitacaoJuridicaRecusada">
        <div class="p-t-20 boxFamilias" v-if="documentosHabilitacaoJuridicaRecusado.length > 0 || documentosDadosBasicosRecusado.length > 0">
          <v-layout row wrap>
            <v-flex p-t-30>
              <div class="tituloBox p-b-30 border-top">
                <div class="bg-primary barraTitulo"></div>
                <h1 class="text-info font-size-14" v-if=" model.tipFornecedor == 'J'">
                  Habilitação <strong>Jurídica</strong>
                </h1>
                <h1 class="text-info font-size-14" v-if=" model.tipFornecedor == 'F'">
                  Dados do <strong>Fornecedor</strong>
                </h1>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="p-t-10 p-b-10" v-for="item in documentosHabilitacaoJuridicaRecusado" :key="item.codDocumento">
            <v-flex xs8>
              <v-card class="card--flex-toolbar">
                <v-toolbar light height="50px" v-bind:class="{'item-aprovado':(item.docSolicitacao.arquivoUploadSituacao==2),'item-reprovado':(item.docSolicitacao.arquivoUploadSituacao==1)}">
                  <v-toolbar-title>
                    <strong>Anexo do(a) {{titleCase(item.nomDocumento)}}:</strong>
                    - {{item.docSolicitacao.arquivoUpload}}<br />
                    <span v-html="formatMotivos(item.docSolicitacao, item.nomMotivo)"></span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>

         

          <v-layout row wrap class="p-t-10 p-b-10" v-for="item in documentosDadosBasicosRecusado" :key="item.codDocumento">
            <v-flex xs8>
              <v-card class="card--flex-toolbar">
                <v-toolbar light height="50px" v-bind:class="{'item-aprovado':(item.docSolicitacao.arquivoUploadSituacao==2),'item-reprovado':(item.docSolicitacao.arquivoUploadSituacao==1)}">
                  <v-toolbar-title>
                    <strong>Anexo do(a) {{titleCase(item.nomDocumento)}}:</strong>
                    - {{item.docSolicitacao.arquivoUpload}}<br />
                    <span v-html="formatMotivos(item.docSolicitacao, item.nomMotivo)"></span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
        <v-flex xs8 v-if="habilitacaoJuridicaRecusada">
          <v-layout class="p-t-10 p-b-10" v-for="item in model.fornecedoresHabilitacaoJuridica" :key="item.cpfCnpj">
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px" v-if="item.habilitacaoJuridicaSituacao==1" v-bind:class="{'item-aprovado':(item.habilitacaoJuridicaSituacao==2),'item-reprovado':(item.habilitacaoJuridicaSituacao==1)}">
                <v-toolbar-title>
                  <strong>{{(item.tipoCadastro=='D') ? $t('label.dirigente') : $t('label.socio')}} :</strong>
                  {{item.cpfCnpj}} - {{item.nome}}<br />
                  <span v-html="formatMotivos(item, item.motivoIndeferimentoStr)"></span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-layout>
        </v-flex>
      </div>


      <div class="p-t-20 boxFamilias" v-if="listaFamiliaRejeitada.length > 0">
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                <strong>Família</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="p-t-10 p-b-10" v-for="item in listaFamiliaRejeitada" :key="item.codGrupo+''+item.familiaAssociada.codFamilia">
          <v-flex xs8>
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px" v-bind:class="{'item-aprovado':(item.familiaFornecSituacao==2),'item-reprovado':(item.familiaFornecSituacao==1)}">
                <v-toolbar-title>
                  <strong>{{item.familiaAssociada.codFamilia}}</strong> - {{item.familiaAssociada.descFamilia}}
                  <br />
                  <span v-html="formatMotivos(item, item.motivoIndeferimentoStr)"></span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <div class="p-t-20 boxFamilias" v-if="listaQualificacaoTecnicaRejeitada.length > 0">
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                Qualificação <strong>Técnica</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="p-t-10 p-b-10" v-for="item in listaQualificacaoTecnicaRejeitada" :key="item.codDocumento">
          <v-flex xs8>
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px" v-bind:class="{'item-aprovado':(item.qualificacaoTecnicaSituacao==2),'item-reprovado':(item.qualificacaoTecnicaSituacao==1)}">
                <v-toolbar-title>
                  <strong>{{retornaNomeQualificacao(item.codDocumento)}}</strong>
                  <br />
                  <span v-html="formatMotivos(item, item.motivoIndeferimentoStr)"></span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-flex>
        </v-layout>
      </div>

      <div
        class="p-t-20 boxFamilias"
        v-if="listaRegularidadeRejeitada.length > 0 &&  enums.tipoDocumento !=null && modelCarregado"
      >
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>

              <h1 class="text-info font-size-14">
                <strong>Regularidade</strong> Fiscal e Trabalhista
              </h1>
            </div>
          </v-flex>
        </v-layout>
        <div v-for="item in enums.tipoDocumento.filter(x=> listaRegularidadeRejeitada.find(y => x.valor == y.tipDocumento))" :key="item.chave+''+item.valor">
          <v-layout row wrap class p-b-20>
            <v-flex xs8>
              <v-card class="card--flex-toolbar">
                <v-toolbar light height="50px" v-bind:class="{'item-aprovado':(tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==2),'item-reprovado':(tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==1)}">
                  <v-toolbar-title>
                    <strong>{{item.descricao}}</strong><br />
                    <span v-html="formatMotivos(listaRegularidadeRejeitada.find(r => item.valor == r.tipDocumento), listaRegularidadeRejeitada.find(r => item.valor == r.tipDocumento).motivoIndeferimentoStr)"></span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div
        class="p-t-20 boxFamilias"
        v-if="this.concordataSituacao == 1 || this.balancoSituacao == 1 || this.balancoSituacao2 == 1 ">
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                <strong>Qualificação</strong> Econômico-Financeira
              </h1>
            </div>
          </v-flex>
        </v-layout>
        <v-flex inputIcon xs8 v-show="this.concordataSituacao == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar light v-bind:class="{'item-aprovado':(model.concordataFalencia.arquivoUploadSituacao == 2),'item-reprovado':(model.concordataFalencia.arquivoUploadSituacao == 1)}">
              <v-toolbar-title>
                <strong>Anexo do Documento - {{$t('label.concordataEFalencia')}}:</strong>
                <br />{{model.concordataFalencia.arquivoUpload}}<br />
                <span v-html="formatMotivos(model.concordataFalencia, model.concordataFalencia.motivoIndeferimentoStr)"></span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>
        <br />
        <v-flex inputIcon xs8 v-show="this.balancoSituacao == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar light v-bind:class="{'item-aprovado':(model.balancoFinanceiro.arquivoUploadSituacao == 2),'item-reprovado':(model.balancoFinanceiro.arquivoUploadSituacao == 1)}">
              <v-toolbar-title>
                <strong>Anexo do Documento - {{$t('label.balanco')}}:</strong>
                <br />{{model.balancoFinanceiro.arquivoUpload}}<br />
                <span v-html="formatMotivos(model.balancoFinanceiro, model.balancoFinanceiro.motivoIndeferimentoStr)"></span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>
        <v-flex inputIcon xs8 v-show="this.balancoSituacao2 == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar light v-bind:class="{'item-aprovado':(model.balancoFinanceiro.arquivoUploadSituacao02 == 2),'item-reprovado':(model.balancoFinanceiro.arquivoUploadSituacao02 == 1)}">
              <v-toolbar-title>
                <strong>Anexo do Documento - {{$t('label.balanco2')}}:</strong>
                <br />{{model.balancoFinanceiro.arquivoUpload02}}<br />
                <span v-html="formatMotivos(model.balancoFinanceiro, model.balancoFinanceiro.motivoIndeferimentoStr02, 'idMotivoIndeferimentoArquivo02_2', 'idMotivoIndeferimentoArquivo02_3', 'idMotivoIndeferimentoArquivo02')"></span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>
      </div>
      <div
        class="p-t-20 boxFamilias"
        v-if="listaUploadDeclaracaoRejeitada.length > 0 && enums.tipoUploadDeclaracao !=null && modelCarregado">
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                Formulários e <strong>Declarações</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="p-t-10 p-b-10" v-for="item in enums.tipoUploadDeclaracao.filter(x=> listaUploadDeclaracaoRejeitada.find(y => x.valor == y.tipDocumento) )" :key="item.chave">
          <v-flex xs8>
            <v-card class="card--flex-toolbar">
              <v-toolbar light v-bind:class="{'item-aprovado':(listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).uploadDeclaracaoSituacao==2),'item-reprovado':(listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).uploadDeclaracaoSituacao==1)}">
                <v-toolbar-title>
                  <strong>{{item.descricao}}</strong>
                  <br />
                  {{listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).arquivoUpload}}
                  <br />
                  <span v-html="formatMotivos(listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento), listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).motivoIndeferimentoStr)"></span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <br />
    <camposAlterados :model="alteracaoModel" v-if="isAlteracaoModelCarregado"></camposAlterados>
    <br />
    <br />
    <div>
      <v-flex xs12 sm6 p-t-20>
        <fieldset>
          <legend class="text-info font-size-18">
            <strong>Tipo de Cadastro Permitido</strong>
          </legend>
      
          <v-flex xs12>          
            <v-radio-group v-model="tipoCertificadoSelecionar" class="mb-0 mt-1" row v-if="(validaCadastroCRC(3) || (model.tipoSolicitacao==2 && OldModel.tipoCertificado == 1)) || (validaCadastroCRS(3) || (model.tipoSolicitacao==2 && OldModel.tipoCertificado == 2)) || (validaCadastroCredenciamento()|| (model.tipoSolicitacao==2 && OldModel.tipoCertificado == 3))">
              <v-radio :label="$t('label.crc')" :value="1" v-if="validaCadastroCRC(3)"></v-radio>
              <v-radio :label="$t('label.crs')" :value="2" v-if="validaCadastroCRS(3)"></v-radio>
              <v-radio
                :label="$t('label.candidato')"
                :value="3"
                v-if="validaCadastroCredenciamento() ||(model.tipoSolicitacao==2 && OldModel.tipoCertificado == 3)"
              ></v-radio>
            </v-radio-group>
            <br />
            <div
              v-if="!((validaCadastroCRC(3) || (model.tipoSolicitacao==2 && OldModel.tipoCertificado == 1)) || (validaCadastroCRS(3) || (model.tipoSolicitacao==2 && OldModel.tipoCertificado == 2)) || (validaCadastroCredenciamento()|| (model.tipoSolicitacao==2 && OldModel.tipoCertificado == 3)))"
            >Nenhum tipo de cadastro permitido.</div>
          </v-flex>
        </fieldset>
      </v-flex>
    </div>
    <v-layout row>
      <v-flex class="p-t-30" v-if="ObterRegistroCadastral">
        <v-form v-model="validFormRelatorio" ref="formAnexoRelatorioInscricaoRegistro">
          <v-card>
            <v-layout row wrap>
              <v-flex xs12>
                <uploadFile
                  @click:append="baixarArquivo(anexoRelatorioInscricaoRegistro.file)"
                  tamanhoMaximo="20MB"
                  :required="true"
                  :label="$t('label.relatorioInscricaoRegistroCadastral')+ '*'"
                  v-model="anexoRelatorioInscricaoRegistro.file"
                  :idFornecedor="model.numCgcFornecedor"
                  accept=".pdf, .PDF"/>
              </v-flex>
            </v-layout>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
    <v-layout row d-inline class="p-t-30">
      <v-flex xs6 sm4 left p-t-30>
        <v-btn large color="info" @click="voltar()">
          <v-icon dark left>arrow_back</v-icon>&nbsp;VOLTAR
        </v-btn>
      </v-flex>
     
      <v-flex xs3 sm4 right p-t-30 

          v-if="fornecedorLoaded && dadosCarregados && $verificaPerfilHabilitador()
              && ( (model.tipoSolicitacao == 1) || // Solicitação nova
                   (model.tipoSolicitacao == 2 && (verificaAlteracaoTipoCertificado() || this.ObterFornecSitSimeb))  
                 )
              && (
                  ($verificaPerfilHabilitadorMaster() && ValidaSocioParaMaster()) || // Se for Validador Master, pode habilitar
                  (podeHabilitar() && podeHabilitarNovo()) // Se não for, verifica as regras normais
                 )">
          <v-btn large color="success" @click="VerificaDuplaConferencia(1)">
            HABILITAR
          </v-btn>
        </v-flex>         
        <v-flex xs3 sm4 right p-t-30
                v-if=" ($verificaPerfilHabilitadorMaster() && ValidaSocioParaMaster() && model.tipoSolicitacao == 2 && !(verificaAlteracaoTipoCertificado() || this.ObterFornecSitSimeb)) 
                || (fornecedorLoaded && dadosCarregados && $verificaPerfilSomenteHabilitador()
                      && model.tipoSolicitacao == 2 
                      && ValidaSocioParaMaster()
                      && !verificaAlteracaoTipoCertificado() // Não é alteração de tipo    
                      && !this.ObterFornecSitSimeb)// Nenhum sócio/dirigente indeferido
                      ">
          <v-btn large color="success" @click="VerificaDuplaConferencia(2)">
            ATUALIZAR
          </v-btn>
        </v-flex>
      <v-flex xs3 sm4 right p-t-30 v-if="$verificaPerfilHabilitador()">
        <v-btn large color="error" @click="openModalConfirmacao()">REJEITAR</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="355">
      <v-card>
        <v-card-text> O Fornecedor foi habilitado com sucesso, <strong>porém</strong> o tipo de cadastro autorizado foi <strong>diferente do solicitado</strong>.
          <br />
          <span v-if="model.tbFornecedores">
            Tipo de Cadastro Solicitado:
            <strong>{{ retornaEnumDescricao('tipoCertificado',model.tipoCertificado)}}</strong>
            <br />
Tipo de Cadastro Aprovado:
            <strong>{{retornaEnumDescricao('tipoCertificado',tipoCertificadoSelecionar)}}</strong>
          </span>
          <br />
          <span v-if="model.tbFornecedores && model.tbFornecedores.vwCRC">
            Número CRC/CRS:
            <strong>{{model.tbFornecedores.vwCRC.numCrc}}</strong>
          </span>
.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" @click="dialog=fecharDialog()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogModalConfirmacao.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirme!</v-card-title>

        <v-card-text>
          <div v-html="dialogModalConfirmacao.msg"></div>
        </v-card-text>

        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="success" @click="cancelarRejeitar()">Cancelar</v-btn>
          </v-flex>

          <v-flex sm6>
            <v-btn large color="info" @click="rejeitar()">Confirmar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogDuplaConferencia.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Informação Dupla Conferência!</v-card-title>

        <v-card-text>
          <div v-html="dialogDuplaConferencia.msg"></div>
        </v-card-text>

        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="success" @click="VoltarDupla()">Fechar</v-btn>
          </v-flex>

          <v-flex sm6>
            <v-btn large color="info" @click="SeguirDuplaConferencia()">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import dominioService from "../../../services/dominioService";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import documentosService from "../../../services/documentosFornecService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Topo from "../../../components/Topo";
import camposAlterados from "./components/campos-alterados";
import moment from 'moment';
export default {
  name: "resumo-habilitador",
  mixins: [util],
  components: { /*Componentes utilizados*/
    Topo,
    camposAlterados
  },
  props: {//Propriedades que o objeto recebe como parametro
  },
  async created() {
    this.$mostrarPreload();
    try {
      const [motivosRes, motivosFamRes, enumsRes] = await Promise.all([
        documentosService.getAllMotivosIndeferimento().catch(err => {
          console.error('Erro ao carregar motivos:', err);
          return { data: [] };
        }),
        documentosService.getAllMotivosIndeferimentoFamilia().catch(err => {
          console.error('Erro ao carregar motivos familia:', err);
          return { data: [] };
        }),
        dominioService.geEnums().catch(err => {
          console.error('Erro ao carregar enums:', err);
          return { data: {} };
        })
      ]);

      this.listaMotivosCompletos = motivosRes.data || [];
      this.listaMotivosFamilia = motivosFamRes.data || [];
      this.enums = enumsRes.data || {};

      this.getlistaMotivosBalanco();
      await this.getFornecedor();
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      this.fornecedorLoaded = true;
      this.$removePreload();
    }

    //Preencher próxima rota ao concluir o resumo
    this.getRotaProximaSolicitacao();
  },


  watch: { //Propriedades assistidas
    model: {
      handler() {}
    }
  },
  data() {//Declaracao de variaveis
    return {
      dialogModalConfirmacao: {
        show: false,
        msg: "Deseja mesmo rejeitar a solicitação?"
      },
      dialogDuplaConferencia: {
        show: false,
        msg: "Essa solicitação está aguardando a dupla conferência.",
        acao: 0
      },    
      valid: true,
      dadosCarregados: false,
      fornecedorLoaded: false,
      ObterRegistroCadastral: false,
      ObterFornecSitSimeb: false,
      validFormRelatorio: true,
      dialog: false,
      isAlteracaoModelCarregado: false,
      alteracaoModel: {},
      model: {},
      OldModel: {},
      upload: {},
      enums: Object,
      dominio: {
        categoria: [],
        paises: []
      },
      tipoDocumento: Object,
      listaFamiliaRejeitada: Object,
      listaQualificacaoTecnicaRejeitada: Object,
      documentosHabilitacaoJuridicaRecusado: [],
      documentosDadosBasicosRecusado: Object,
      listaRegularidadeRejeitada: Object,
      listaUploadDeclaracaoRejeitada: Object,
      listaDocumentoSolicitacaoRejeitada: Object,
      listaDocsQualificacaoTecnica: [],
      itemRejeitado: {},
      tipoCertificadoSelecionar: String,
      arrayFamiliasDocumento: [],
      modelCarregado: false,
      listaMotivosCompletos: [],
      listaMotivosFamilia: [],
      listaMotivosBalanco: [],
      anexoRelatorioInscricaoRegistro: {
        novoAnexo: false,
        file: undefined
      },
      rotaProximaSolicitacao: String,
    };
  },
  computed: {//Campos computados
    documentosRejeitados() {
      //verifica se tem pelo menos um documento rejeitado
      var docRejeitado = false;
      if (this.model != null) {
        if (this.model.arquivoUploadSituacao == 1 || this.habilitacaoJuridicaRecusada ||
          this.documentosHabilitacaoJuridicaRecusado.length > 0 || this.listaFamiliaRejeitada.length > 0 ||
          this.listaRegularidadeRejeitada.length > 0 || this.listaUploadDeclaracaoRejeitada.length > 0 ||
          this.listaDocumentoSolicitacaoRejeitada.length > 0 ||
          this.listaQualificacaoTecnicaRejeitada.length > 0 ||
          this.concordataSituacao === 1 || this.balancoSituacao === 1 || this.balancoSituacao2 === 1) { /* concordataSituacao e balancoSituacao são do tipo number */
          docRejeitado = true;
        }
      }
      return docRejeitado;
    },
    habilitacaoJuridicaRecusada() {
      //verifica se tem documento de habilitacao juridica rejeitado
      var docRejeitado = false;
      //this.model.fornecedoresHabilitacaoJuridica é tipo number
      if (this.model.fornecedoresHabilitacaoJuridica != null) {
        if (this.model.fornecedoresHabilitacaoJuridica.filter(x => x.habilitacaoJuridicaSituacao === 1).length > 0)
          docRejeitado = true;
      }
      return docRejeitado;
    },
    concordataSituacao() {
      //verifica a situacao da concordata
      var situacao = 0;
      if (this.model != null) {
        if (this.model.concordataFalencia != null) {
          situacao = this.model.concordataFalencia.arquivoUploadSituacao;
        }
      }
      return situacao;
    },
    balancoSituacao() {
      //verifica s tiuacao do balanco
      var situacao = 0;
      if (this.model != null) {
        if (this.model.balancoFinanceiro != null) {
          situacao = this.model.balancoFinanceiro.arquivoUploadSituacao;
        }
      }
      return situacao;
    },
    balancoSituacao2() {
      //verifica s tiuacao do balanco
      var situacao = 0;
      if (this.model != null) {
        if (this.model.balancoFinanceiro != null) {
          situacao = this.model.balancoFinanceiro.arquivoUploadSituacao02;
        }
      }
      return situacao;
    }
  },
  methods: {//Declaracao de todos os metodos
    formatMotivos(item, motivo1Str, motivo2Prop = "idMotivoIndeferimentoArquivo2", motivo3Prop = "idMotivoIndeferimentoArquivo3", motivo1Prop = "idMotivoIndeferimentoArquivo") {
      if (!item && !motivo1Str) return "";

      var obj = item;
      if (item && item.docSolicitacao && typeof item.docSolicitacao === 'object') {
        obj = Object.assign({}, item, item.docSolicitacao);
      }

      var isFamilia = !!(obj && (obj.idFamiliaFornec || obj.IdFamiliaFornec || (obj.codGrupo && obj.numFamilia) || (obj.CodGrupo && obj.NumFamilia) || obj.familiaAssociada || obj.FamiliaAssociada));

      var getVal = function(target, propName) {
        if (!target || !propName) return null;
        if (target[propName] !== undefined && target[propName] !== null) return target[propName];
        var pascal = propName.charAt(0).toUpperCase() + propName.slice(1);
        if (target[pascal] !== undefined && target[pascal] !== null) return target[pascal];

        if (propName === 'idMotivoIndeferimentoArquivo') {
          return target.IdMotivoIndeferimentoArquivo ||
                 target.id_motivo_indeferimento_arquivo ||
                 target.idMotivoIndeferimento ||
                 target.IdMotivoIndeferimento ||
                 null;
        }
        if (propName === 'idMotivoIndeferimentoArquivo2') {
          return target.IdMotivoIndeferimentoArquivo2 ||
                 target.id_motivo_indeferimento_arquivo2 ||
                 target.Id_motivo_indeferimento_arquivo2 ||
                 target.idMotivoIndeferimentoArquivo_2 ||
                 target.Id_motivo_indeferimento_arquivo_2 ||
                 target.idMotivoIndeferimento2 ||
                 target.IdMotivoIndeferimento2 ||
                 null;
        }
        if (propName === 'idMotivoIndeferimentoArquivo3') {
          return target.IdMotivoIndeferimentoArquivo3 ||
                 target.id_motivo_indeferimento_arquivo3 ||
                 target.Id_motivo_indeferimento_arquivo3 ||
                 target.idMotivoIndeferimentoArquivo_3 ||
                 target.Id_motivo_indeferimento_arquivo_3 ||
                 target.idMotivoIndeferimento3 ||
                 target.IdMotivoIndeferimento3 ||
                 null;
        }
        if (propName === 'idMotivoIndeferimentoArquivo02') {
          return target.IdMotivoIndeferimentoArquivo02 ||
                 target.idMotivoIndeferimentoArquivo2 ||
                 null;
        }
        if (propName === 'idMotivoIndeferimentoArquivo02_2') {
          return target.IdMotivoIndeferimentoArquivo02_2 ||
                 target.idMotivoIndeferimentoArquivo2_2 ||
                 target.Id_motivo_indeferimento_arquivo2_2 ||
                 null;
        }
        if (propName === 'idMotivoIndeferimentoArquivo02_3') {
          return target.IdMotivoIndeferimentoArquivo02_3 ||
                 target.idMotivoIndeferimentoArquivo2_3 ||
                 target.Id_motivo_indeferimento_arquivo2_3 ||
                 null;
        }

        return target[propName] || null;
      };

      var self = this;
      var getMotivoDesc = function(id) {
        if (!id) return null;
        var numId = Number(id);
        var match = function(x) {
          if (!x) return false;
          var xId = Number(x.mtNumero != null ? x.mtNumero : (x.MtNumero != null ? x.MtNumero : (x.numero != null ? x.numero : (x.Numero != null ? x.Numero : x.id))));
          return xId === numId;
        };

        var primaryList = isFamilia ? (self.listaMotivosFamilia || []) : (self.listaMotivosCompletos || []);
        var secondaryList = isFamilia ? (self.listaMotivosCompletos || []) : (self.listaMotivosFamilia || []);

        var found = primaryList.find(match);
        if (!found) {
          found = secondaryList.find(match);
        }

        return found ? (found.mtMotivo || found.MtMotivo || found.nomeMotivo || found.NomeMotivo || found.desMotivo || found.DesMotivo || found.mtDesc || found.MtDesc) : null;
      };

      var firstStr = (motivo1Str && typeof motivo1Str === 'string' && motivo1Str.trim().length > 0) ? motivo1Str.trim() : null;
      if (!firstStr && obj) {
        var m1Prop = motivo1Prop || "idMotivoIndeferimentoArquivo";
        var val1 = getVal(obj, m1Prop);
        firstStr = getMotivoDesc(val1);
      }

      var val2 = getVal(obj, motivo2Prop);
      var val3 = getVal(obj, motivo3Prop);

      var desc2 = getMotivoDesc(val2);
      var desc3 = getMotivoDesc(val3);

      var motivosArr = [];
      if (firstStr && typeof firstStr === 'string' && firstStr.trim().length > 0) {
        motivosArr.push("<strong>Motivo:</strong> " + firstStr.trim());
      }
      if (desc2 && typeof desc2 === 'string' && desc2.trim().length > 0) {
        var d2 = desc2.trim();
        var itemStr2 = "<strong>Motivo:</strong> " + d2;
        if (motivosArr.indexOf(itemStr2) === -1) {
          motivosArr.push(itemStr2);
        }
      }
      if (desc3 && typeof desc3 === 'string' && desc3.trim().length > 0) {
        var d3 = desc3.trim();
        var itemStr3 = "<strong>Motivo:</strong> " + d3;
        if (motivosArr.indexOf(itemStr3) === -1) {
          motivosArr.push(itemStr3);
        }
      }

      if (motivosArr.length === 0) return "";
      return '<div style="margin-top: 8px;">' + motivosArr.join("<br />") + '</div>';
    },
    getRotaProximaSolicitacao() {
      const IdFornecSolicitacao = this.setIdFornecSolicitacao();
      fornecedorService
        .getProximaSolicitacaoAnalista(this.$store.getters.getUsuarioId, IdFornecSolicitacao)
        .then(response => { /*resposta do servico*/
          if (response.data) {
            this.rotaProximaSolicitacao = "/arearestrita/habilitador/consultar-solicitacao/" + response.data
          } else{
            this.rotaProximaSolicitacao = "/arearestrita/habilitador/solicitacao"
          }
        })
        .catch(() => {
            this.rotaProximaSolicitacao = "/arearestrita/habilitador/solicitacao"
        })
    },
    getlistaMotivosBalanco(){ //pega os motivos de indeferimento de balanco
      documentosService.getMotivosIndeferimento(11).then(response => { /*resposta do servico*/
          this.listaMotivosBalanco = response.data; /*dados de retorno*/
      })
    },
    openModalConfirmacao() { //mostrar diaolog de confirmação
      this.dialogModalConfirmacao.show = true;
    },
    VoltarDupla(){
      this.dialogDuplaConferencia.show = false;
    },
    SeguirDuplaConferencia(){
      if(this.dialogDuplaConferencia.acao == 1){
        this.habilitar();
      }
      if(this.dialogDuplaConferencia.acao == 2){
        this.atualizar();
      }
      if(this.dialogDuplaConferencia.acao == 3){
        this.openModalConfirmacao();
      }
     
    },

    VerificaDuplaConferencia(acao){
      this.dialogDuplaConferencia.acao = acao;
      
      fornecedorService
        .validaDuplaConferencia({
          fornecedorSolicitacao: this.model        
        })
        .then(response => { /*resposta do servico*/
         
               this.dialogDuplaConferencia.show = response.data;
           if(!response.data){         
            this.SeguirDuplaConferencia();
           }  
        })
        .catch(() => {
          this.$removePreload(); /*Ocultar o PreLoad*/
        });


    },

    async getFornecedor() {
  this.$mostrarPreload(); // Exibir o PreLoad
  this.dadosCarregados = false; // Controlar quando tudo estiver pronto

  const IdFornecSolicitacao = this.setIdFornecSolicitacao();

  try {
    const response = await fornecedorService.getSolicitacaoIncluiSimpas(IdFornecSolicitacao);
    
    this.model = response.data.novoModel ? response.data.novoModel : response.data;
    this.OldModel = response.data.oldModel ? response.data.oldModel : {};

    // Se não vier nada, garantir que seja um array vazio
    this.model.familiaSolicitacao = this.model.familiaSolicitacao || [];
    this.model.qualificacaoTecnica = this.model.qualificacaoTecnica || [];
    this.model.regularidadeFiscTrab = this.model.regularidadeFiscTrab || [];
    this.model.uploadDeclaracao = this.model.uploadDeclaracao || [];
    this.model.documentosSolicitacao = this.model.documentosSolicitacao || [];

    this.listaFamiliaRejeitada = this.model.familiaSolicitacao.filter(x => x.familiaFornecSituacao === 1);
    this.listaQualificacaoTecnicaRejeitada = this.model.qualificacaoTecnica.filter(x => x.qualificacaoTecnicaSituacao === 1);
    this.listaRegularidadeRejeitada = this.model.regularidadeFiscTrab.filter(x => x.regularidadeFiscTrabSituacao === 1);
    this.listaUploadDeclaracaoRejeitada = this.model.uploadDeclaracao.filter(x => x.uploadDeclaracaoSituacao === 1);
    this.listaDocumentoSolicitacaoRejeitada = this.model.documentosSolicitacao.filter(x => x.arquivoUploadSituacao === 1);

    // Carregar documentos
    const documentos = await documentosService.getDocumentosFornecedorSolicitacao(IdFornecSolicitacao);
    if (documentos.data.length > 0) {
      this.documentosHabilitacaoJuridicaRecusado = documentos.data.filter(
        x => x.numHabilitacao === "2" && x.docSolicitacao.arquivoUploadSituacao == 1
      );
      this.documentosDadosBasicosRecusado = documentos.data.filter(
        x => x.numHabilitacao === "1" && x.docSolicitacao.arquivoUploadSituacao == 1
      );
    }

    // Buscar alterações se houver modelo antigo
    if (response.data.oldModel) {
      const retorno = await fornecedorService.getAlteracoesSolicitacao(response.data);
      this.alteracaoModel = retorno.data ? retorno.data : {};
      this.isAlteracaoModelCarregado = true;
    }

    // Buscar registro cadastral
    const registroCadastral = await fornecedorService.ObtemRegistroCadastral(this.model.numCgcFornecedor);
    this.ObterRegistroCadastral = registroCadastral.data;

    // Buscar situação do fornecedor
    await this.ObtemSituacaoFornecedorSimeb(this.model.numCgcFornecedor);

    // Chamadas sincronas mantidas fora do async
    this.getDocRelatorioRegistroCadastralFornec();
    this.getListaDocsQualificacaoTecnica();
    this.tipoCertificadoSelecionar = this.model.tipoCertificado;
    this.setTipoCertificadoSelecionar();
    this.anexoRelatorioInscricaoRegistro.novoAnexo = this.setAnexoRelatorioInscricaoRegistro();
    this.carregaRegularidade();

    // Agora os dados estão carregados
    this.dadosCarregados = true;
  } catch (error) {
    console.error("Erro ao carregar fornecedor:", error);
  } finally {
    this.$removePreload(); // Ocultar o PreLoad sempre, mesmo se houver erro
  }
}
,
    setIdFornecSolicitacao(){
      return (this.$route.params.id && this.$verificaPerfilHabilitador()? this.$route.params.id : null);
    },
    setTipoCertificadoSelecionar(){ /* tipoCertificadoSelecionar é do tipo number*/
      
      if ( // tipo solicitação é alteração e se não for mudança de certificado, então sugerir o tipo de certificado que ele já é
        this.model.tipoSolicitacao === 2 && this.OldModel.tipoCertificado == this.model.tipoCertificado
      ) {
        
        if (this.tipoCertificadoSelecionar === 2 && !this.validaCadastroCRS(3)) {
          this.tipoCertificadoSelecionar = 3;
        }
        if (this.tipoCertificadoSelecionar === 3 && this.modelCarregado && !this.validaCadastroCredenciamento()) {
          this.tipoCertificadoSelecionar = null;
        }
      }
      else
      {
     
        if (this.tipoCertificadoSelecionar === 1 && !this.validaCadastroCRC(3)) {
          this.tipoCertificadoSelecionar = 2;
        }
        if (this.tipoCertificadoSelecionar === 2 && !this.validaCadastroCRS(3)) {
          this.tipoCertificadoSelecionar = 3;
        }
        if (this.tipoCertificadoSelecionar === 3 && this.modelCarregado && !this.validaCadastroCredenciamento()) {
          this.tipoCertificadoSelecionar = null;
        }
      }
    },
    setAnexoRelatorioInscricaoRegistro(){
     return (this.model.docRelatorioRegistroCadastral ? false : true);
    },
    asterico(){ //verificando obrigatoriedade
      if(this.tipoCertificadoSelecionar){
        /* tipoCertificadoSelecionar e OldModel.tipoCertificado são do tipo number*/
        if (this.OldModel.tipoCertificado === 1 && this.tipoCertificadoSelecionar === 2
          && this.tipoCertificadoSelecionar!==this.OldModel.tipoCertificado) {
          return " *";
        } else {
          return "";
        }
       }else{
         return "*";
       }
    },
    carregaRegularidade() { //carregar os documentos de regularidade
      this.enums.tipoDocumento.filter(item => {
        var chave = item.chave;
        this.$set(this.tipoDocumento, chave, {
          tipDocumento: item.valor
        });
        var regularidadeFiscTrab = this.listaRegularidadeRejeitada.find(x => x.tipDocumento === item.valor);
        if (regularidadeFiscTrab) {
          this.$set(this.tipoDocumento, chave, regularidadeFiscTrab);
        }
      });
    },
     ValidaSocioParaMaster() { //carregar os documentos de regularidade
         if (this.model.fornecedoresHabilitacaoJuridica != null) {
            if (this.model.fornecedoresHabilitacaoJuridica.filter(x => x.habilitacaoJuridicaSituacao === 1).length > 0
            ) {
              return false;
            }
          }
        return true;
    },
    validaCadastroBasico() {
      
      
        if (this.model.fornecedoresHabilitacaoJuridica != null) {
          if (this.model.fornecedoresHabilitacaoJuridica.filter(x => x.habilitacaoJuridicaSituacao === 1).length > 0
          ) {
            return false;
          }
        }
      
      //Se pessoa Jurídica
      if (this.model.tipFornecedor === "J") {        
        //se documentos de habilitação juridica ou algum dos socios/dirigentes
        if (this.documentosHabilitacaoJuridicaRecusado.length > 0) {
          return false;
        }
      
        if (this.model.fornecedoresHabilitacaoJuridica != null) {
          if (this.model.fornecedoresHabilitacaoJuridica.filter(x => x.habilitacaoJuridicaSituacao === 1).length > 0
          ) {
            return false;
          }
        }
      } //Pessoa Física
      else {
        if (this.documentosDadosBasicosRecusado.length > 0) {
          return false;
        }
      }
      //Tem que ter pelo menos uma familia válida
      
      if (this.model.familiaSolicitacao != null && (this.model.tipoSolicitacao == 1 || this.ObterFornecSitSimeb)) {
        if (this.model.familiaSolicitacao.filter(x => x.familiaFornecSituacao === 2).length === 0) {
          return false;
        }
      }


      if (this.model.uploadDeclaracao != null) {
        if (this.model.uploadDeclaracao.filter(x => x.uploadDeclaracaoSituacao === 1 && (x.tipDocumento === 71)).length > 0) {
         
          return false;
        }
      }
     
      //Todas as regularidades tem que estar aprovadas

        // Regra para documentos NÃO obrigatórios
        const naoObrigatorio = (doc) => 
          (doc.tipDocumentoCodigo === 1 && this.model.flagEstrangeiro === '1') ||
          (doc.tipDocumentoCodigo === 2) ||
          (doc.tipDocumentoCodigo === 3 && (this.model.categoria === 'MEI' || this.model.tipoCertificado === 3)) ||
          (doc.tipDocumentoCodigo === 3 && this.model.tipoCertificado === 3 && this.model.tipFornecedor === 'F');

        // Filtra apenas os documentos obrigatórios (tirando os NÃO obrigatórios)
        const documentosObrigatorios = this.model.regularidadeFiscTrab.filter(doc => !naoObrigatorio(doc));

        // Verifica se existe pelo menos um obrigatório rejeitado
        const existeObrigatorioRejeitado = documentosObrigatorios.some(doc => doc.regularidadeFiscTrabSituacao == 1);

        // Caso exista rejeitado → retorna false
        if (existeObrigatorioRejeitado) {
          return false;
        }
      var docExigidoRecusado = false;
      var docElegidoNecessarioRecusado = false;
      //Validar as qualificações técnicas
      if (this.listaQualificacaoTecnicaRejeitada.length > 0 && (this.model.tipoSolicitacao == 1 || this.ObterFornecSitSimeb)) {
        //Qualificações tecnicas rejeitadas
        this.listaQualificacaoTecnicaRejeitada.filter(item => {
          
          this.listaDocsQualificacaoTecnica.filter(doc => {
            if (item.codDocumento === doc.codDocumento) {
              //Testar se a qualificacao tecnica é de uma familia que está aprovada
              if (this.model.familiaSolicitacao.filter(
                  x => x.familiaFornecSituacao === 2 && x.codGrupo === doc.codGrupo && x.numFamilia === doc.numFamilia).length > 0
              ) {
                //Se for qualquer documento exigível estiver rejeitado
                if (doc.exigido === "S") {
                  docExigidoRecusado = true;
                  return false;
                }
                //Teste dos documentos elegíveis
                if (doc.elegivel === "S") {
                  //Varrendo as familias e seus respectivos documentos
                  this.arrayFamiliasDocumento.filter(e => {
                    var listaDocumentos;
                    listaDocumentos = e.documentos;
                    if (e.codGrupo === doc.codGrupo && e.numFamilia === doc.numFamilia
                    ) {
                      //Se o documento recusado é elegível para a familia em questão
                      if (
                        listaDocumentos.filter(z => z.codDocumento === doc.codDocumento).length > 0
                      ) {
                        listaDocumentos.filter(itemDocumentos => {
                          //Verificar se não tem outro documento elegivel aprovado
                          
                          if (
                            itemDocumentos.elegivel === "S" &&
                            itemDocumentos.codDocumento !== doc.codDocumento &&
                            this.model.qualificacaoTecnica.filter(
                              x =>
                                x.qualificacaoTecnicaSituacao === 2 &&
                                x.codDocumento === itemDocumentos.codDocumento
                            ).length === 0
                          ) {
                            //Não tem outro elegivel aprovado para a familia
                            docElegidoNecessarioRecusado = true;
                          }
                        });
                      }
                    }
                  });
                }
              }
            }
          });
        });
        if (docExigidoRecusado || docElegidoNecessarioRecusado) {
          return false;
        }
      }
      return true;
    },
    
    obrigarBalanco2() {
    let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(
        x => x.tipDocumento === 1
    );

    if (!regularidadeFiscTrabAberturaEmp || !regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa) {
        return true; // Se não tem data, mantém regra atual de obrigatoriedade
    }

    // Cria uma variável temporária para armazenar a data ajustada apenas para esta validação
    let dataAberturaAjustada = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa);

    let dataDoisAnosNovo = dataAberturaAjustada.clone().add(2, 'years');
    let dataAtualNovo = moment(); // Data do dia atual

    // Caso a empresa tenha menos de 2 anos, nunca obriga
    if (dataAtualNovo.isBefore(dataDoisAnosNovo)) {
        return false;
    }

    // Verifica se a data de abertura está definida e se é entre 15/12 e 31/12
    if (
        dataAberturaAjustada.isSameOrAfter(dataAberturaAjustada.year() + '-12-15') &&
        dataAberturaAjustada.isSameOrBefore(dataAberturaAjustada.year() + '-12-31')
    ) {
        // Adiciona dias para tornar a data 01/01 do ano seguinte
        dataAberturaAjustada.add(1, 'year').startOf('year');
    }

    let dataDoisAnos = dataAberturaAjustada.clone().add(2, 'years');
    let dataSolicitacao = moment(this.model.dataSolicitacao);
    let dataAtual = moment();

    let ultimoDiaUtilJunho = moment(`${dataSolicitacao.year()}-06-30`);
    if (ultimoDiaUtilJunho.day() === 6) { // Sábado → sexta
        ultimoDiaUtilJunho.subtract(1, 'days');
    } else if (ultimoDiaUtilJunho.day() === 0) { // Domingo → sexta
        ultimoDiaUtilJunho.subtract(2, 'days');
    }

    // Se a empresa completou 2 anos no primeiro semestre e ainda não chegou o último dia útil de junho
    if (
        dataDoisAnos.year() === dataAtual.year() &&
        dataDoisAnos.month() < 6 && // Janeiro a Junho (0 a 5 no moment.js)
        dataAtual.isBefore(ultimoDiaUtilJunho)
    ) {
        return false; // Não obriga o balanço 02 antes do prazo estabelecido
    }

    // Se já passou o prazo do último dia útil de junho, exige normalmente o balanço 02
    return true;
}
,

    validaCadastroCRC(Local) {

      if(Local == 3 && (this.model.tipoCertificado == 2 || this.model.tipoCertificado == 3))
      {
        return false;
      }
      if(Local == 2 && (this.model.tipoCertificado == 2 || this.model.tipoCertificado == 3))
      {
        return true;
      }

      if(this.model.tipoCertificado == 2 || this.model.tipoCertificado == 3)
      {
        return true;
      }
      

      let ValidaBotao = true;
       
      if(Local == 1 && (this.tipoCertificadoSelecionar === 2 || this.tipoCertificadoSelecionar === 3))
      {
        ValidaBotao = false;
      }
       //arrumar concordata para quando solicitacao nao tem CONCORDATA/BALANÇO
      if(this.model.balancoFinanceiro != null && this.model.concordataFalencia != null)
      {
        let condConcordata = (!this.concordataSituacao || this.concordataSituacao === 1);

       let condBalanco1 = ((this.balancoSituacao === 1 || !this.balancoSituacao) 
                           && this.model.tipFornecedor === "J");

       let condBalanco2 = ((this.balancoSituacao2 === 1 || 
                            (!this.balancoSituacao2 && this.obrigarBalanco2())) 
                           && this.model.tipFornecedor === "J");


       if (condConcordata || condBalanco1 || condBalanco2) {
          return false;
        }
      }
        if (this.model.uploadDeclaracao != null) {
        if (this.model.uploadDeclaracao.filter(x => x.uploadDeclaracaoSituacao === 1 && (x.tipDocumento === 64 || x.tipDocumento === 71)).length > 0) {
         
          return false;
        }
      }

      if(this.model.tipoCertificado == 1  && ValidaBotao){
      
      var uploadAux = null;
      var achouDocRejeitado = false;
      if (!this.validaCadastroBasico()) 
      {             
        return false;
      }
// }
      //Testar os formulários e declarações
      //Se for pessoa Física
      if (this.model.tipFornecedor === "F") {
        //Declaração de Superveniência
        //Se achar o documento que era obrigatorio mas está rejeitado
        if (this.enums != null) {
          this.enums.tipoUploadDeclaracao.filter(y => {
            if (y.chave === "DeclaracaoSuperveniencia") {
              //Se não tiver cadastrado
              if (this.model.uploadDeclaracao.filter(x => x.tipDocumento === y.valor).length === 0) {
                achouDocRejeitado = true;
               
                return false;
              }
              uploadAux = this.listaUploadDeclaracaoRejeitada.find(x => x.tipDocumento === y.valor);
              if (uploadAux != null) {
                achouDocRejeitado = true;              
                return false;
              }
            }
          });
        }
      } //Se for pessoa Jurídica
      else {
        //Declaração do Empregador, Declaração de Superveniência
        //Se achar o documento que era obrigatorio mas está rejeitado
        if (this.enums != null) {
          this.enums.tipoUploadDeclaracao.filter(y => {
            if (y.chave === "DeclaracaoEmpregador" || y.chave === "DeclaracaoSuperveniencia") {
              //Se não tiver cadastrado
              if (this.model.uploadDeclaracao.filter(x => x.tipDocumento === y.valor).length === 0) {
                achouDocRejeitado = true;              
                return false;
              }
              uploadAux = this.listaUploadDeclaracaoRejeitada.find(
                x => x.tipDocumento === y.valor
              );
              if (uploadAux != null) {
                achouDocRejeitado = true;               
                return false;
              }
            }
          });
        }
      }
    }
    else
    {
      return true;
    }
    
      if (achouDocRejeitado)
        return false;
      return true;
    },
    validaCadastroCRS(Local) {
      if(Local == 3 && ( this.model.tipoCertificado == 3))
      {
        return false;
      }

      if(Local == 2 && ( this.model.tipoCertificado == 3))
      {
        return true;
      }
      if( this.model.tipoCertificado == 3)
      {
        return true;
      }
      // if(Local == 1 && this.model.tipoCertificado == 1){
      //   return true;
      // }
     if (this.model.uploadDeclaracao != null) {
        if (this.model.uploadDeclaracao.filter(x => x.uploadDeclaracaoSituacao === 1 && (x.tipDocumento === 64 || x.tipDocumento === 71)).length > 0) {
         
          return false;
        }
      }
      let ValidaBotao = true;
       
      if(Local == 1 && ( this.tipoCertificadoSelecionar === 3))
      {
        ValidaBotao = false;
      }

      if (!this.validaCadastroBasico()) {  
        return false;
      }
     
      if(this.model.tipoCertificado == 2 && ValidaBotao)
      {
        
      var uploadAux = null;
      var achouDocRejeitado = false;
 
      //Testar os formulários e declarações
      //Se for pessoa Física
      if (this.model.tipFornecedor === "F") {
        //Declaração de Superveniência
        //Se achar o documento que era obrigatorio mas está rejeitado
        if (this.enums != null) {
          this.enums.tipoUploadDeclaracao.filter(y => {
            if (y.chave === "DeclaracaoSuperveniencia") {
              //Se não tiver cadastrado
              if (this.model.uploadDeclaracao.filter(x => x.tipDocumento === y.valor).length === 0) {
                achouDocRejeitado = true;
                return false;
              }
              uploadAux = this.listaUploadDeclaracaoRejeitada.find(x => x.tipDocumento === y.valor);
              if (uploadAux != null) {
                achouDocRejeitado = true;
                return false;
              }
            }
          });
        }
      } //Se for pessoa Jurídica
      else {
        //Declaração do Empregador, Declaração de Superveniência
        //Se achar o documento que era obrigatorio mas está rejeitado
        if (this.enums != null) {
          this.enums.tipoUploadDeclaracao.filter(y => {
            if (y.chave === "DeclaracaoEmpregador" || y.chave === "DeclaracaoSuperveniencia") {
              //Se não tiver cadastrado
              if (this.model.uploadDeclaracao.filter(x => x.tipDocumento === y.valor).length === 0) {
                achouDocRejeitado = true;
                return false;
              }
              uploadAux = this.listaUploadDeclaracaoRejeitada.find(x => x.tipDocumento === y.valor);
              if (uploadAux != null) {
                achouDocRejeitado = true;
                return false;
              }
            }
          });
        }
      }
    }
    else{
      return true;
    }
    
      if (achouDocRejeitado) return false;
      return true;
    },
    validaCadastroCredenciamento() {
                     
      if (this.model.fornecedoresHabilitacaoJuridica != null) {
        if (this.model.fornecedoresHabilitacaoJuridica.some(x => x.habilitacaoJuridicaSituacao === 1)) {
          return false;
        }
      }

      if (this.model.tipFornecedor === "J") {
        if (this.documentosHabilitacaoJuridicaRecusado.length > 0) {
          return false;
        }
      } else {
        if (this.documentosDadosBasicosRecusado.length > 0) {
          return false;
        }
      }

      if (this.model.familiaSolicitacao != null && (this.model.tipoSolicitacao == 1 || this.ObterFornecSitSimeb)) {
        if (this.model.familiaSolicitacao.filter(x => x.familiaFornecSituacao === 2).length === 0) {
          return false;
        }
      }

      if (this.model.uploadDeclaracao != null) {
        if (this.model.uploadDeclaracao.some(x => x.uploadDeclaracaoSituacao === 1 && x.tipDocumento === 71)) {
          return false;
        }
      }

      const documentosObrigatorios = this.model.regularidadeFiscTrab.filter(doc =>
        doc.tipDocumentoCodigo !== 3
      );

      if (documentosObrigatorios.some(doc => doc.regularidadeFiscTrabSituacao === 1)) {
        return false;
      }

      return true;
    },

    verificaBotaoAtivo(){
         // Se existir Declaração de Superveniência rejeitado
      const DecSuperveniencia = this.model.uploadDeclaracao;
      const DecSupervenienciaFilt = DecSuperveniencia.filter(item => item.tipDocumento === 71 && item.uploadDeclaracaoSituacao === 1);      
      if(DecSupervenienciaFilt.length > 0) {        
        return false;

      } 
      return true;
    },
    retornaNomeQualificacao(codDocumento) {
      //retornar o nome da qualificacao tecnica
      var nome = "";
      if (this.listaDocsQualificacaoTecnica.length > 0) {
        nome = this.listaDocsQualificacaoTecnica.find(r => codDocumento === r.codDocumento).nomDocumento;
        nome +=this.listaDocsQualificacaoTecnica.find(r => codDocumento === r.codDocumento).exigido === "S"?
        " - Exigível" : " - Elegível";
      }
      return nome;
    },
    
    cancelarRejeitar() {
      //metodo para cancelar a opção de rejeite antes da persistencia
      this.dialogModalConfirmacao.show = false;
    },
    rejeitar() {
      //rejeitar a solicitacao do fornecedor
      this.model.situacaoSolicitacao = 4;
      this.dialogModalConfirmacao.show = false;
      return fornecedorService.habilitarRejeitarSolicitacao({fornecedorSolicitacao: this.model}).then(response => { /*resposta do servico*/
          this.model = response.data; /*dados de retorno*/
          this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
          if (this.$verificaPerfilHabilitador()) {
            this.$router.push(this.rotaProximaSolicitacao);
          }
          return true;
        })
        .catch(() => {
          this.$removePreload(); /*Ocultar o PreLoad*/
        });
    },
    fecharDialog() {
      this.$router.push(this.rotaProximaSolicitacao);
    },
    verificaAlteracaoTipoCertificado() {
      //verificar se houve mudança de tipo de certificado
   
      let retorno = false;
      if (
        this.model.tipoSolicitacao === 2 && // tipo solicitação é igual a alteração
        this.tipoCertificadoSelecionar !== this.OldModel.tipoCertificado
      ) {
        retorno = true;
      }
      return retorno;
    },
    podeHabilitar() {

      //verificacao se pode habilitar o fornecedor    
      let retorno = false;          

          if (        
          this.verificaBotaoAtivo() &&
        (this.validaCadastroCRC(1) &&
          this.validaCadastroCRS(1) &&
          this.validaCadastroCredenciamento())
      ) {
        
        retorno = true;

      }
 
      return retorno;
    },
        podeHabilitarNovo() {
      //verificacao se pode habilitar o fornecedor    

      let retorno = false;   
    if (
        (this.validaCadastroCRC(2) ||
          this.validaCadastroCRS(2) ||
          this.validaCadastroCredenciamento()
         )
      )
      {   
        retorno = true;
      }

      return retorno;
    },
    //habilitar o fornecedor
    habilitar(atualizar) {
      // Verifica se o campo relatório registro cadastral está prenchido se estiver sendo exibido
      if ((this.ObterRegistroCadastral && !this.$refs.formAnexoRelatorioInscricaoRegistro.validate())) {
        return false;
      }
      if (atualizar) {
        if (this.documentosRejeitados) {
          //Atualizada com ressalvas
          this.model.situacaoSolicitacao = 7;
        } else {
          //Atualizada
          this.model.situacaoSolicitacao = 8;
        }
      } else {
        if (this.documentosRejeitados) {
          //Atualizada com ressalvas
          this.model.situacaoSolicitacao = 7;
        }else{
        this.model.situacaoSolicitacao = 5;
        }
        
      }
      this.model.tipoCertificado = this.tipoCertificadoSelecionar;
      fornecedorService
        .habilitarRejeitarSolicitacao({
          fornecedorSolicitacao: this.model,
          anexoRelatorioInscricaoRegistro: this.anexoRelatorioInscricaoRegistro
        })
        .then(response => { /*resposta do servico*/
          this.$toasted.success(
            this.$t("messages.cadastro.aprovadoComSucesso")
          );
          if (response.data.tipoCertificado !== this.model.tipoCertificado) {
            this.dialog = true;
            this.model = response.data; /*dados de retorno*/
          } else {
            if (this.$verificaPerfilHabilitador()) {
              this.$router.push(this.rotaProximaSolicitacao);
            }
          }
          return true;
        })
        .catch(() => {
          this.$removePreload(); /*Ocultar o PreLoad*/
        });
    },
    atualizar() {
      //atualizar o cadastro do fornecedor
      this.model.tipoCertificado = this.OldModel.tipoCertificado;
      this.habilitar(true);
    },
    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (!valor || !this.enums[_enum]) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao.toUpperCase() : null;
    },
    voltar() {
      //voltar para a solicitacao
      if (this.$verificaPerfilHabilitador()) {
        this.$router.push("/arearestrita/habilitador/consultar-solicitacao/" + this.model.idFornecSolicitacao
        );
      }
    },
    getListaDocsQualificacaoTecnica() {
      //resgatar a lista de docuemntos de qualificacao tecnica
      dominioService.getListaDocsQualificacaoTecnica(this.model.familiaSolicitacao).then(response => { /*resposta do servico*/
          this.listaDocsQualificacaoTecnica = response.data; /*dados de retorno*/
          this.fn_DocPorFamilia();
          this.modelCarregado = true;
        });
    },

     ObtemSituacaoFornecedorSimeb(numCgc) {
      //resgatar a lista de docuemntos de qualificacao tecnica
        
        fornecedorService.ObtemSituacaoFornecedorSimeb(numCgc).then(response => { /*resposta do servico*/
          
          this.ObterFornecSitSimeb = response.data; /*dados de retorno*/    
        });

        
    },

    fn_DocPorFamilia() {
      
      //resgatar documento por familia
      this.arrayFamiliasDocumento = [];
      this.model.familiaSolicitacao.forEach(item => {
        this.arrayFamiliasDocumento.push({
          idFamiliaFornec: item.idFamiliaFornec,
          descFamilia: item.familiaAssociada.descFamilia,
          codGrupo: item.codGrupo,
          numFamilia: item.numFamilia,
          documentos: this.listaDocsQualificacaoTecnica.filter(
            x => x.codGrupo === item.codGrupo && x.numFamilia === item.numFamilia
          )
        });
      });
    },
    baixarArquivo(arquivo) {
      //baixar arquivo
      fornecedorService.baixarArquivo(
        arquivo,
        this.model.numCgcFornecedor.replace(/[\W_]+/g,"")
      );
    },
    getDocumentosFornecedor(idFornecSolicitacao){
      //resgatar documentos do fornecedor
      documentosService.getDocumentosFornecedorSolicitacao(idFornecSolicitacao).then(response => { /*resposta do servico*/
        this.listaDocFornecSolicitacao = response.data; /*dados de retorno*/
        if (this.listaDocFornecSolicitacao.find(x=> x.codDocumento == 140).docSolicitacao.arquivoUpload)
          this.upload.novoRG = false
      });
    },
    getDocRelatorioRegistroCadastralFornec() {
      //#158837-Forcar a resgatar o documento Relatorio Registro cadastral caso exista
      if(this.model && !this.model.docRelatorioRegistroCadastral){
        fornecedorService.GetDocRelatorioRegistroCadastral(this.model.numCgcFornecedor)
          .then(response => { /*resposta do servico*/
          this.model.docRelatorioRegistroCadastral = response.data;
        });
      }
    },

  }
};
</script>
<style scoped> /*CSS especifico do componente*/
.v-list__tile {
  height: 60px;
}
.v-list__tile__sub-title {
  font-size: 11px;
}
.v-list__tile--active {
  font-family: gothambold;
}
.v-list__tile--active .v-list__tile__title {
  color: #333;
}
.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}
.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
  white-space: normal;
}
.v-toolbar__title {
  white-space: normal;
  line-height: 1.4;
}
.card--flex-toolbar >>> .v-toolbar {
  height: auto !important;
}
.card--flex-toolbar >>> .v-toolbar__content {
  height: auto !important;
  padding-top: 18px;
  padding-bottom: 18px;
  min-height: 50px;
}
</style>